import {Modal} from "@ui-kitten/components";
import {Text, View, ScrollView, useWindowDimensions} from "react-native";
import * as React from "react";
import { useKeyboard } from '@react-native-community/hooks'

export const ModalLayout = ({
                                children,
                                title,
                                icon,
                                close,
                                footer,
                                padding,
                                spaceTitleContent
                            }) => {

    const { height } = useWindowDimensions();
    const {keyboardShown, keyboardHeight} = useKeyboard();


    return <Modal visible={true} onBackdropPress={close}
                  backdropStyle={{ backgroundColor: 'rgba(0,0,0,0.6)'}}
                  style={{left: 50, right: 50}}>
        <View style={{width: '100%', marginTop: 20, maxHeight: (height - (keyboardShown ? keyboardHeight : 0) - 120), backgroundColor: 'white', borderRadius: 15, overflow: 'hidden'}}>
            {/*<View style={{position: 'absolute', zIndex: 1, right:15, top: 15}}>*/}
            {/*    <TouchableOpacity onPress={close}>*/}
            {/*        <Text><AntDesign name="closecircle" size={17} color="black" /></Text>*/}
            {/*    </TouchableOpacity>*/}
            {/*</View>*/}
            {title && <View style={{
                flexDirection: 'row',
                // backgroundColor: '#a0c946',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 12
                // marginBottom: typeof spaceTitleContent == 'undefined' ? 15 : spaceTitleContent,
            }}>
                <View style={{marginRight: 10 }}>{icon}</View>
                <Text style={{
                    flex: 1,
                    fontSize: 22,
                    fontWeight: 'bold',
                    color: '#a0c946',
                    textShadowColor: 'black'
                }}>{title}</Text>
            </View>}
            <View style={{height: 1, backgroundColor: '#a0c946'}}/>
            <ScrollView keyboardShouldPersistTaps='always' style={{
                // margin: 0,
                // marginTop: 0,
                // padding: typeof padding == 'undefined' ? 15 : padding,
                // margin: 15
            }}>
                <View style={{padding: 15}}>{children}</View>
            </ScrollView>
            {footer && <View>
                {footer}
            </View>}
        </View>
        <View style={{height: keyboardShown ? keyboardHeight : 0}}></View>
    </Modal>
}